<template>
  <router-view></router-view>
  <notifications position="top center" style="margin-top: 10px"/>
</template>

<script lang="ts" setup>
</script>

<style>
body{
  overflow:hidden;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
